import { Slot } from '@radix-ui/react-slot'
import { useControllableState } from '@radix-ui/react-use-controllable-state'
import React from 'react'

import { Filters } from './Filters'
import { Tab } from './Tab'
import { TabbedFilters } from './TabbedFilters'
import { TabContent } from './TabContent'
import { TabsList } from './TabsList'
import { Popover } from '../Popover'

interface FiltersDropdownProps {
  align?: 'start' | 'end';
  children: React.ReactNode;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  portalContainer?: Element;
  trigger: React.ReactNode | (({ open }: { open: boolean }) => React.ReactNode);
  width?: 'auto' | 'full';
  withPortal?: boolean;
  zIndex?: number;
}

export function FiltersDropdown ({
  align = 'start',
  children,
  defaultOpen = false,
  onOpenChange,
  open: openProp,
  portalContainer,
  trigger,
  width = 'auto',
  withPortal = true,
  zIndex,
}: FiltersDropdownProps) {
  const [open, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  })

  function renderPopoverTrigger () {
    if (typeof trigger === 'function') {
      return trigger({ open })
    }

    return trigger
  }

  return (
    <Popover
      align={align}
      defaultOpen={defaultOpen}
      open={open}
      onOpenChange={(bool) => {
        setOpen(bool)
      }}
      portalContainer={portalContainer}
      side='bottom'
      trigger={
        <Slot
          onKeyDown={(event) => {
            if (event.key === 'ArrowDown') {
              setOpen(true)
            }
          }}
        >
          {renderPopoverTrigger()}
        </Slot>
      }
      width={width === 'full' ? 'triggerWidth' : 'auto'}
      withPortal={withPortal}
      zIndex={zIndex}
    >
      {children}
    </Popover>
  )
}

FiltersDropdown.Tab = Tab
FiltersDropdown.TabContent = TabContent
FiltersDropdown.TabsList = TabsList
FiltersDropdown.Filters = Filters
FiltersDropdown.TabbedFilters = TabbedFilters
